const MoneyInput = ({ value, onChange }) => {

  const formatDisplay = (num) => {
    const floatVal = (num / 100).toFixed(2);
    const formatted = floatVal
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `R$ ${formatted}`;
  };

  const handleMoneyChange = (e) => {
    // remove tudo que não for número
    const onlyNums = e.target.value.replace(/\D/g, "");
    const newValue = onlyNums ? parseInt(onlyNums, 10) : 0;

    onChange((newValue / 100).toFixed(2))

  };

  const displayValue = formatDisplay(
    Math.round(parseFloat(value || "0") * 100)
  );


  return <input
    type="text"
    value={displayValue}
    onChange={handleMoneyChange}
    placeholder="R$ 0,00"
    maxLength={25}
    inputMode="numeric"
  />
}

export default MoneyInput